<template>
    <div>
        <b-alert
            variant="secondary"
            :show="true"
        >
            <h2>My Students</h2>
            <router-link
                class="sc-btn pill"
                :to="{ name: 'parent_add_student' }"
            >
                <font-awesome-icon
                    icon="plus"
                    class="mr-2"
                />
                Add Student
            </router-link>
            <a
                v-if="pdfUrl"
                :href="pdfUrl"
                download="teacher-classes.pdf"
                class="sc-btn pill"
                target="_blank"
            >
                <font-awesome-icon icon="download" class="mr-2"></font-awesome-icon>
                Download PDF
            </a>
        </b-alert>
        <div
            class="student-grid"
        >
            <template
                v-for="(student, idx) in students"
            >
                <b-card
                    :key="idx"
                    v-if="student"
                    footer-bg-variant="white"
                >
                    <router-link :to="{ name: 'student_settings', params: { id: student.id } }" class="bottom-cog float-right">
                        <font-awesome-icon icon="cog" size="lg"></font-awesome-icon>
                    </router-link>
                    <router-link :to="{ name: 'parent_view_student', params: { id: student.id } }">
                        <h5>
                            <i v-if="student.has_account" class="fas fa-address-card"></i>
                            {{ student.first_name }}
                        </h5>
                    </router-link>
                    <template #footer>
                        <div class="d-flex justify-content-between">
                            <template v-if="student.enrolled">
                                <div class="text-success my-2">
                                    <font-awesome-icon icon="check-circle" class="mr-2"></font-awesome-icon>
                                    Registered
                                </div>
                                <router-link
                                    v-if="settings.ALLOW_REGISTRATION"
                                    :to="{ name: 'register_student', params: { id: student.id }, query: { back: '/students' }}"
                                    class="sc-btn"
                                >
                                    Change Registration
                                    <font-awesome-icon icon="arrow-right" class="ml-2" />
                                </router-link>
                            </template>
                            <template v-else>
                                <div class="text-secondary my-2">
                                    <font-awesome-icon icon="times-circle" class="mr-2" />
                                    Unregistered
                                </div>
                                <router-link
                                    v-if="settings.ALLOW_REGISTRATION"
                                    :to="{ name: 'register' }"
                                    class="sc-btn"
                                >
                                    Register Student
                                    <font-awesome-icon icon="arrow-right" class="ml-2" />
                                </router-link>
                            </template>
                        </div>
                    </template>
                </b-card>
            </template>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import StudentAddit from '../student/StudentForm.vue';

export default {
    name: "student-list",
    computed: mapState([
        "students",
        "settings"
    ]),
    data() {
        return {
            pdfUrl: ""
        };
    },
    mounted() {
        this.updateStudents();
    },
    methods: {
        updateStudents() {
            this.$api.get(
                "/api/register/get-students"
            ).then(({ data }) => {
                if (data.students.length)
                    this.$store.commit("updateStudents", data);
                if (data.pdfUrl)
                    this.pdfUrl = data.pdfUrl;
            });
        }
    },
    components: { StudentAddit }
}
</script>
<style scoped>
    .student-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 2fr));
        grid-auto-rows: 1fr;
        gap: 1rem;
    }
    .student-grid > * {
        position: relative;
    }
</style>